/**
 * Interest Form Service
 * Handles resident interest form submissions to unified multi-city API
 */

import type { InterestFormData } from '@core';

// @ts-ignore - Vite env vars
const API_BASE_URL = import.meta.env?.VITE_API_BASE_URL || 'https://api.toolboxlogic.com';

export interface InterestSubmissionResponse {
  success: boolean;
  error?: string;
  data?: {
    id: string;
    market_key: string;
    created_at: string;
  };
}

export async function submitInterestForm(
  formData: InterestFormData,
): Promise<InterestSubmissionResponse> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/louisiana/lake-charles/interest-form`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        zip: formData.zip,
        phone: formData.phone,
        interested: formData.interested,
        // Lake Charles-specific fields
        planInterest: formData.planInterest,
        facebookGroups: formData.facebookGroups,
        isChampion: formData.isChampion,
        featurePreference: formData.featurePreference,
        comments: formData.comments,
      }),
    });

    const result = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: result.message || `Server error: ${response.status}`,
      };
    }

    return {
      success: true,
      data: result.data,
    };
  } catch (error) {
    console.error('Interest form submission error:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Network error occurred',
    };
  }
}
